//
//
//
//
//
//
export default {
  name: "BlankLayout"
};